/* tslint:disable */
/* eslint-disable */
/**
 * Ion.Reporting.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  PermissionsPermissionType,
  PermissionsPermissionTypeFromJSON,
  PermissionsPermissionTypeFromJSONTyped,
  PermissionsPermissionTypeToJSON,
} from "./";

/**
 *
 * @export
 * @interface PermissionsDeveloperPermission
 */
export interface PermissionsDeveloperPermission {
  /**
   *
   * @type {string}
   * @memberof PermissionsDeveloperPermission
   */
  developerId?: string | null;
  /**
   *
   * @type {PermissionsPermissionType}
   * @memberof PermissionsDeveloperPermission
   */
  type?: PermissionsPermissionType;
}

export function PermissionsDeveloperPermissionFromJSON(json: any): PermissionsDeveloperPermission {
  return PermissionsDeveloperPermissionFromJSONTyped(json, false);
}

export function PermissionsDeveloperPermissionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PermissionsDeveloperPermission {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    developerId: !exists(json, "developerId") ? undefined : json["developerId"],
    type: !exists(json, "type") ? undefined : PermissionsPermissionTypeFromJSON(json["type"]),
  };
}

export function PermissionsDeveloperPermissionToJSON(value?: PermissionsDeveloperPermission | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    developerId: value.developerId,
    type: PermissionsPermissionTypeToJSON(value.type),
  };
}
